import { PERMISSIONS } from '../../constants';
import list from './InvoiceList';
import show from './InvoiceShow';

export default {
  list,
  show,
  name: 'invoices',
  permissions: [PERMISSIONS.LIST_INVOICE],
}